exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fam-code[data-v-ebf815f4]{font-weight:900}", ""]);

// exports
